// test626
(626 && 0);
